"use client";


export const Shimmer = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`animate-shimmer bg-gradient-to-r from-transparent via-gray-200 to-transparent bg-[length:50%_100%] ${className}`} />
  );
};

export const JobCardSkeleton = () => {
  return (
    <div className="group relative h-full overflow-hidden rounded-xl border border-gray-300 bg-white p-6">
      <div className="flex flex-col gap-5">
        {/* Title and Department Chip */}
        <div>
          <div className="flex items-center gap-3 mb-2">
            <div className="h-8 bg-gray-200 rounded w-3/5">
              <Shimmer className="h-full w-full" />
            </div>
            <div className="h-6 w-20 bg-gray-200 rounded-full">
              <Shimmer className="h-full w-full" />
            </div>
          </div>
          {/* Description */}
          <div className="space-y-2">
            <div className="h-5 bg-gray-200 rounded w-full">
              <Shimmer className="h-full w-full" />
            </div>
            <div className="h-5 bg-gray-200 rounded w-4/5">
              <Shimmer className="h-full w-full" />
            </div>
          </div>
        </div>

        {/* Location and Employment Type Chips */}
        <div className="flex flex-wrap gap-3">
          <div className="h-7 w-24 bg-gray-200 rounded-full">
            <Shimmer className="h-full w-full" />
          </div>
          <div className="h-7 w-20 bg-gray-200 rounded-full">
            <Shimmer className="h-full w-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const JobCardsSkeleton = ({ count = 6 }: { count?: number }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {Array(count).fill(0).map((_, i) => (
        <JobCardSkeleton key={i} />
      ))}
    </div>
  );
};